import styled from "styled-components";

export const ProductComponentCopyContainer = styled.div`
  .discounted-mrp-container{
    min-height: 40px;
    max-height:40px;
    display: flex;
    align-items: center;


  }
  .discounted-mrp-container h5{
    display: block;
    margin: 0px;
  }
  .productCard{
    display: flex;
    /* align-items: center; */
  }
`;
